module.exports = __webpack_public_path__ + "static/media/straven_8.63670a34.jpg";